import { createReducer, on } from '@ngrx/store';
import { IApiResponseError } from '@app/api/interfaces/common/api-response-error.interface';
import { initialState, IUserMeState } from './user-me.state';
import { getUserMe, userMeError, getUserMeSuccess } from './user-me.actions';
import { BaseErrorStatus } from '@app/api/enums/base-error-status.enum';
import { IUserMe } from '@app/api/interfaces/user-me.interface';

export const userMeReducer = createReducer(
  initialState,
  on(
    getUserMe,
    (state): IUserMeState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    getUserMeSuccess,
    (
      state,
      action: {
        data: IUserMe;
      }
    ): IUserMeState => ({
      ...state,
      data: action.data || null,
      loaded: true,
      loading: false,
    })
  ),
  on(
    userMeError,
    (state, action: { error: IApiResponseError<BaseErrorStatus> }): IUserMeState => ({
      ...state,
      error: action.error,
      loading: false,
    })
  )
);
